import { render, staticRenderFns } from "./CriticalOrderModal.vue?vue&type=template&id=0366b7c4&scoped=true"
import script from "./CriticalOrderModal.vue?vue&type=script&lang=js"
export * from "./CriticalOrderModal.vue?vue&type=script&lang=js"
import style0 from "./CriticalOrderModal.vue?vue&type=style&index=0&id=0366b7c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0366b7c4",
  null
  
)

export default component.exports